import { render, staticRenderFns } from "./BreedingStats.vue?vue&type=template&id=524731de&scoped=true&"
import script from "./BreedingStats.vue?vue&type=script&lang=ts&"
export * from "./BreedingStats.vue?vue&type=script&lang=ts&"
import style0 from "./BreedingStats.vue?vue&type=style&index=0&id=524731de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524731de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer})
